import React, { useState, useEffect } from "react";
import { Avatar, Drawer, Row, Col, Card } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { List, ListItem, ListItemAvatar, ListItemText } from "@mui/material";
import MainHeader from "../../../../common/MainHeader";
import IconsList from "../../../../common/IconsList";

export default function VitalInfo(props) {
  const [open, setOpen] = useState(false);
  const [warningIconsList, setwarningIconsList] = useState([]);
  const [warningIconsInfo, setwarningIconsInfo] = useState("");
  const [firstResponderNotes, setFirstResponderNotes] = useState("");

  useEffect(() => {
    const { firstResponderNotes, warningIcons } = props;
    if (firstResponderNotes) {
      setFirstResponderNotes(firstResponderNotes);
    } else {
      setFirstResponderNotes("");
    }
    if (warningIcons) {
      setwarningIconsList(warningIcons);
    } else {
      setwarningIconsList([]);
    }
  }, [props]);

  const warningInfo = (info) => {
    setwarningIconsInfo(info);
    setOpen(true);
  };

  return (
    <div style={{ background: "#FFF", borderRadius: "10px", padding: "28px" }}>
      <Row gutter={[16, 16]}>
        <Col>
          <MainHeader title={`Vital Info ( ${warningIconsList.length} )`} />
        </Col>
      </Row>

      <div
        style={{
          minHeight: "325px",
          maxHeight: "325px",
          overflow: "auto",
          overflowX: "hidden",
          marginTop: "10px",
          background: "#FFF",
        }}
      >
        <div>
          {firstResponderNotes !== undefined &&
            firstResponderNotes !== null &&
            firstResponderNotes !== "" && (
              <span style={{ color: "tomato" }}>{firstResponderNotes}</span>
            )}
        </div>

        <div
          style={{
            borderRadius: "10px",
            background: "#f5f5f5",
            marginTop: "10px",
            minHeight: "310px",
            padding: "0px 5px 0px",
          }}
        >
          {warningIconsList.length > 0 ? (
            <List>
              <Row>
                {warningIconsList.map((warningIcon, index) => (
                  <Col
                    xxl={{ span: 12 }}
                    xl={{ span: 12 }}
                    lg={{ span: 12 }}
                    md={{ span: 24 }}
                    sm={{ span: 24 }}
                    xs={{ span: 24 }}
                  >
                    <Card
                      className="card-container"
                      hoverable
                      bodyStyle={{ margin: "0px", padding: "0px" }}
                      style={{ margin: "5px" }}
                    >
                      <ListItem
                        style={{ cursor: "pointer" }}
                        key={index}
                        onClick={() => warningInfo(warningIcon)}
                      >
                        <ListItemAvatar>
                          <Avatar size={48} src={warningIcon?.securedFileUrl} />
                        </ListItemAvatar>
                        <ListItemText
                          primary={
                            <span style={{ fontSize: "12px" }}>
                              {warningIcon?.optionName || ""}
                            </span>
                          }
                        />
                      </ListItem>
                    </Card>
                  </Col>
                ))}
              </Row>
            </List>
          ) : (
            <Row justify={"center"}>
              <Col
                style={{
                  padding: "30px",
                  textAlign: "center",
                  marginTop: "50px",
                }}
              >
                <ExclamationCircleOutlined
                  style={{ fontSize: "100px", color: "#ccc" }}
                />
                <h3 style={{ textAlign: "center", color: "#ccc" }}>
                  Records Not Found
                </h3>
              </Col>
            </Row>
          )}
        </div>
        <Drawer
          title={null}
          placement="top"
          closable={false}
          onClose={() => setOpen(false)}
          open={open}
          getContainer={false}
          style={{ borderRadius: "10px" }}
        >
          <IconsList
            firstResponderNotes={firstResponderNotes}
            warningIcons={warningIconsList}
            warningIconsInfo={warningIconsInfo}
            handleClose={() => setOpen(false)}
          />
        </Drawer>
      </div>
    </div>
  );
}
